import type { EventCategory } from './base';

export const KitchenEvents = {
  CUSTOMER_KITCHEN_REPORT_GENERATED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      menuWeekIds: [] as string[],
      canteenId: '' as string,
      orderVolume: 0 as number,
      includesDietaryBreakdown: false as boolean,
      reportType: '' as string,
      weeksRequested: 0 as number,
    },
  },
  BARCODE_SCANNED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      canteenId: '' as string,
      mealTime: '' as string,
      scannerType: 'camera' as 'camera' | 'barcode',
      scanResult: 'success' as 'success' | 'error',
      cardId: '' as string | undefined,
      hasOrder: false as boolean | undefined,
      errorType: '' as string | undefined,
      orderCount: 0 as number | undefined,
    },
  },
  UNPLANNED_SERVICE_RECORDED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      canteenId: '' as string,
      mealTime: '' as string,
      source: 'scan' as 'scan' | 'manual',
      hasMeal: false as boolean,
      /** False on a repeat tap for a serving already recorded; counts filter on true. */
      created: true as boolean,
      /** unplanned_service.id: joins the event to its row. */
      serviceId: '' as string,
      /**
       * The served worker's auth user id; set only when the worker was picked by
       * name search, whatever the `source`. Never set together with `cardId`.
       */
      servedUserId: '' as string | undefined,
      /**
       * The worker's card; set when the worker was found by card, both on the scan
       * path and on a manual card lookup (`source: 'manual'`). Not joinable to
       * `servedUserId`: the same worker carries different ids on the two paths.
       */
      cardId: '' as string | undefined,
      /** The kiosk-local date the row was recorded under. */
      serviceDate: '' as string,
      mealId: '' as string | null,
    },
  },
  UNPLANNED_SERVICE_FAILED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      canteenId: '' as string,
      mealTime: '' as string,
      source: 'scan' as 'scan' | 'manual',
      serviceDate: '' as string,
      errorCode: 'unknown' as 'has_order' | 'user_not_found' | 'user_not_active' | 'unknown',
    },
  },
} as const;
